export const INITIALIZE_PAYMENT_REQUEST = 'INITIALIZE_PAYMENT_REQUEST';
export const INITIALIZE_PAYMENT_SUCCESS = 'INITIALIZE_PAYMENT_SUCCESS';
export const INITIALIZE_PAYMENT_FAILURE = 'INITIALIZE_PAYMENT_FAILURE';

export const VERIFY_PAYMENT_REQUEST = 'VERIFY_PAYMENT_REQUEST';
export const VERIFY_PAYMENT_SUCCESS = 'VERIFY_PAYMENT_SUCCESS';
export const VERIFY_PAYMENT_FAILURE = 'VERIFY_PAYMENT_FAILURE';

export const CLEAR_PAYMENT_ERROR = 'CLEAR_PAYMENT_ERROR';
export const CLEAR_PAYMENT_MESSAGE = 'CLEAR_PAYMENT_MESSAGE';
